let getters = {
  quickLinksNewDashboard(state) {
    return state.quickLinksNewDashboard;
  },
  bbpsImages(state) {
    return state.bbpsImages;
  },
  serviceType(state) {
    return state.serviceType;
  }
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/quickLinksNewDashboard/getters.js